import {
  Box,
  ListItemContent,
  ListItemContextMenu,
  ListItemUnreadBadge,
} from '@frameio/vapor';
import { Avatars } from './Avatars';
import { Body } from './Body';
import { ContextMenuContent } from './ContextMenuContent';
import { SecureReviewerContextMenuContent } from './ContextMenuContent/SecureReviewerContextMenuContent';
import { Footer } from './Footer';
import TEXT from './generated/TEXT/NotificationCell';
import { Header } from './Header';
import styles from './NotificationCell.module.css';
import { Thumbs } from './Thumbs';
import type { NotificationGroups, NotificationsActionCallback } from './types';

TEXT.DEFINE({
  /** Accessibility label for context menu button */
  showMenuAriaLabel: 'Show menu',
});

export type NotificationCellProps = Pick<
  NotificationGroups,
  'id' | 'isRead'
> & {
  updateNotificationsReadStatus: (args: NotificationsActionCallback) => void;
  href: string;
  projectId?: string;
  shareId?: string;
  notificationType: NotificationGroups['__typename'];
  onNotificationLinkClick: (args: NotificationsActionCallback) => void;
};

export function NotificationCell({
  href,
  id,
  isRead: isNotificationGroupRead,
  notificationType,
  updateNotificationsReadStatus,
  onNotificationLinkClick,
  projectId,
  shareId,
}: NotificationCellProps) {
  return (
    <ListItemContent
      adornmentAfter={
        <Box className={styles.adornmentAfter}>
          <Thumbs id={id} notificationType={notificationType} />

          {projectId && (
            <ListItemContextMenu
              buttonAccessibilityLabel={TEXT.showMenuAriaLabel}
              content={
                <ContextMenuContent
                  href={href}
                  isRead={isNotificationGroupRead}
                  onNewTabLinkClick={onNotificationLinkClick}
                  projectId={projectId}
                  updateNotificationsReadStatus={updateNotificationsReadStatus}
                />
              }
              variant="right-click-only"
            />
          )}

          {shareId && (
            <ListItemContextMenu
              buttonAccessibilityLabel={TEXT.showMenuAriaLabel}
              content={
                <SecureReviewerContextMenuContent
                  href={href}
                  isRead={isNotificationGroupRead}
                  onNewTabLinkClick={onNotificationLinkClick}
                  updateNotificationsReadStatus={updateNotificationsReadStatus}
                />
              }
              variant="right-click-only"
            />
          )}

          <ListItemUnreadBadge
            data-testid="notification-cell-badge-button"
            isUnread={!isNotificationGroupRead}
            onToggle={() => updateNotificationsReadStatus({})}
          />
        </Box>
      }
      adornmentBefore={<Avatars id={id} notificationType={notificationType} />}
      data-testid="notification-cell"
      description={<Body id={id} notificationType={notificationType} />}
      label={<Header id={id} notificationType={notificationType} />}
      meta={<Footer id={id} notificationType={notificationType} />}
    />
  );
}
